<template>
  <div class="container d-flex align-items-center flex-column mt-1">
    <div class="maincontent-bg d-flex flex-column">
      <div class="container text-left mt-2 mb-2 text-playgame">
        กฎระเบียบ
      </div>
      <div class="container">
        <img width="100%" height="auto" src="../assets/04-06/security/security.png" alt="faq-img" />
      </div>
      <div class="container text-left" style="color:white">
        <div class="termofuse-text mt-3 mb-3">
          • ระบบจัดการดูแลธุรกรรม การเงินต่างๆ
          เป็นระบบเดียวกับที่มาตรฐานสถาบันการเงินใช้
        </div>
        <div class="termofuse-text mt-3 mb-3">
          • ปกป้องปกปิดข้อมูลของท่านอย่างปลอดภัยด้วยระบบที่ทันสมัย
        </div>
        <div class="termofuse-text mt-3 mb-3">
          • บัญชีที่ใช้งานไม่สามารถ Log In เข้าใช้งานพร้อมกันได้
        </div>
        <div class="termofuse-text mt-3 mb-3">
          • ทีมงานผู้ชำนาญคอยดูแลตลอด 24
          ชั่วโมงคอยตรวจสอบการทำธุรกรรมและปัญหาต่างๆอย่างเข้มงวด
        </div>
        <div class="termofuse-text mt-3 mb-3">
          • ป้องกันการใช้โปรแกรมโกง และการเจาะระบบจากมิจฉาชีพ
          ข้อมูลไม่รั่วไหลปลอดภัยมั่นใจได้ 100%
        </div>
      </div>
    </div>
    <div class="maincontent-bg-end"></div>
  </div>
</template>

<script>
export default {
  name: 'security',
};
</script>
